export default __webpack_public_path__ + "static/media/headerg.a8c77bf9.jpg";